/**
 * Test ID utilities for Card component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Card container
 * @param identifier - Card identifier (e.g., 'user-profile', 'settings')
 * @returns Test ID string
 */
export const setCardTestId = (identifier: string): string => generateTestId("Card", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardHeader
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardHeaderTestId = (cardIdentifier: string): string =>
  generateTestId("CardHeader", cardIdentifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardContent
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardContentTestId = (cardIdentifier: string): string =>
  generateTestId("CardContent", cardIdentifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardFooter
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardFooterTestId = (cardIdentifier: string): string =>
  generateTestId("CardFooter", cardIdentifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardTitle
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardTitleTestId = (cardIdentifier: string): string =>
  generateTestId("CardTitle", cardIdentifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardDescription
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardDescriptionTestId = (cardIdentifier: string): string =>
  generateTestId("CardDescription", cardIdentifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for CardAction
 * @param cardIdentifier - Parent card identifier
 * @returns Test ID string
 */
export const setCardActionTestId = (cardIdentifier: string): string =>
  generateTestId("CardAction", cardIdentifier.replace(/\s+/g, "-").toLowerCase());
